import { memo } from "react";

const PublicRouteContainer = ({ component: Component, ...rest }: any) => {
  return <Component {...rest} />;
};

export default memo(PublicRouteContainer);
